/*@ngInject*/
const UMSLog = function ($log, logUtil) {

    this.debug = function (message) {
        $log.debug(message);
    };

    this.error = function (error, url) {
        if (_.isString(error)) {
            error = new Error(error);

            // In IE11, creating a new Error does not automatically populate the stack property,
            // which is needed for StackTraceJS parsing. So, in order to generate the stack, throw
            // the new error, catch it, and set the stack.
            if (!error.stack) {
                try {
                    throw error;
                } catch (e) {
                    error.stack = e.stack;
                }
            }
        }

        $log.error(error);

        return logUtil.logError(error, url);
    };

    this.info = function (message) {
        $log.info(message);
    };

    this.warn = function (message) {
        $log.warn(message);
    };
};

angular.module('umCore')
    .service('umsLog', UMSLog);
